<template>
	<div>
		<SpinLoader v-if="loading" />
		<div v-if="!loading && !data.items.length" class="text-center mt-3">
			<span class="reward-text fs--13 fw--600">No stickers found.</span>
		</div>

		<div v-if="!loading && data.items.length > 0">
			<!-- Reward Stickers -->

			<v-row v-if="stickerType && stickerType == StickerType.REWARD" no-gutters class="mx-2">
				<v-col cols="12" class="text-center px-7" :class="[size === 'md' && 'md-heading']">
					<p class="reward-text fs--13 fw--600 mb-0">
						Unlock the ability to use these rewards on
						<span class="white--text">{{ streamerDisplayName }}'s</span> channel!
					</p>
				</v-col>
				<v-col
					:cols="size === 'sm' ? 12 : 6"
					class="reward-stickers mt-0"
					:class="size === 'md' && 'px-1'"
					v-for="s in stickers"
					:key="s.id">
					<StickerReward :id="s.id" :sticker="s" @onStickerClick="actions.onStickerClick" />
				</v-col>
			</v-row>

			<!-- TTS Stickers -->

			<v-row v-else-if="stickerType && stickerType == StickerType.TTS" class="stickers mx-1" no-gutters>
				<v-col v-for="s in stickers" :key="s.id" :cols="size === 'sm' ? 6 : 4" class="pa-1">
					<StickerTTS :id="s.id" :sticker="s" @onStickerClick="actions.onStickerClick" />
				</v-col>
			</v-row>

			<v-row
				v-else-if="!stickerType || (stickerType != StickerType.REWARD && stickerType != StickerType.TTS)"
				class="stickers mx-1"
				no-gutters>
				<v-col v-for="s in stickers" :key="s.id" :cols="size === 'sm' ? 6 : 4" class="pa-1">
					<template v-if="s.stickerType === StickerType.TTS">
						<StickerTTS :id="s.id" :sticker="s" @onStickerClick="actions.onStickerClick" />
					</template>
					<template v-else>
						<Sticker :id="s.id" :sticker="s" @onStickerClick="actions.onStickerClick" />
					</template>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { computed, ref } from 'vue';
import { useStore } from '@/store';
import SpinLoader from '@/components/panel/SpinLoader';
import StickerReward from '@/components/panel/Stickers/StickerReward.vue';
import Sticker from '@/components/panel/Stickers/Sticker.vue';
import StickerTTS from '@/components/panel/Stickers/StickerTTS.vue';
import { StickerType } from '@/utils/constants';
export default {
	name: 'AllStickers',
	components: {
		StickerReward,
		Sticker,
		StickerTTS,
		SpinLoader,
	},
	props: {
		data: Object,
		// see constants.js:StickerType
		stickerType: {
			type: String,
			required: false,
		},
		loading: Boolean,
	},
	emits: ['onStickerClick'],
	setup(props, ctx) {
		const clickedSticker = ref(null);
		const store = useStore();
		const size = computed(() => store.state.size);
		const stickers = computed(() => {
			let stickerItems = [];

			if (!props.stickerType) {
				// Sort Stickers by HOT, TTS, CUSTOM, REWARD, and Others

				const hotItems = props.data.items.filter(item => item.stickerType === StickerType.GLOBAL && item.isHot);

				const ttsItems = props.data.items.filter(item => item.stickerType === StickerType.TTS);

				const customItems = props.data.items.filter(item => item.stickerType === StickerType.CUSTOM);

				const rewardItems = props.data.items.filter(item => item.stickerType === StickerType.REWARD);

				const others = props.data.items.filter(
					item =>
						item.stickerType !== StickerType.REWARD &&
						item.stickerType !== StickerType.CUSTOM &&
						item.stickerType !== StickerType.TTS &&
						!(item.stickerType === StickerType.GLOBAL && item.isHot),
				);

				stickerItems = [...hotItems, ...ttsItems, ...customItems, ...rewardItems, ...others];

				if (!store.state.isMobile) {
					const start = props.data.currentPage * props.data.perPage,
						end = start + props.data.perPage;
					return stickerItems.slice(start, end);
				} else {
					return stickerItems;
				}
			} else {
				if (!store.state.isMobile) {
					const start = props.data.currentPage * props.data.perPage,
						end = start + props.data.perPage;
					return props.data.items.slice(start, end);
				} else {
					return props.data.items;
				}
			}
		});

		const actions = {
			onStickerClick(sticker) {
				clickedSticker.value = null;
				clickedSticker.value = { ...sticker };
				ctx.emit('onStickerClick', clickedSticker.value);
			},
		};

		const streamerDisplayName = computed(() => {
			return store.state.streamerDisplayName;
		});

		const bitsCreditAmount = computed(() => {
			return store.state.bitsCreditAmount;
		});

		return {
			actions,
			size,
			stickers,
			StickerType,
			streamerDisplayName,
			bitsCreditAmount,
		};
	},
};
</script>
